import { message, Button, Form } from "antd";
import { useEffect } from "react";
import { useGlobalState } from "../../components/global";
import ContentImageUploader from "../components/ContentImageUploader";
import CustomQuill from "../components/CustomQuill";

export default function Guide() {
    const { jsonRequest } = useGlobalState();
    const [form] = Form.useForm();

    const replaceImageSrcWithInit = async (htmlContent: string): Promise<string> => {
        const imgSrcRegex = /<img[^>]*src=["']([^"']*)["'][^>]*>/g;
        let match;
        let newContent = htmlContent;
        while ((match = imgSrcRegex.exec(htmlContent)) !== null) {
            const originalSrc = match[1];
            try {
                // 调用 init 方法获取处理后的链接
                const processedSrc = await init(originalSrc.replace(/%3A/g, ':'));
                // 替换原 src 为处理后的链接
                newContent = newContent.replace(originalSrc, processedSrc);
            } catch (error) {
                console.error("图片链接处理失败:", originalSrc, error);
            }
        }
        return newContent;
    };

    const init = async (url: any) => {
        const result = await jsonRequest.get(`/common/oss-file-visit-url`, { fileUrl: url })
            .then((resp: any) => resp.json());
        return result?.data;
    };

    const imgUploadApi = async (fd: any) => {
        const OSSData = await getOSSData();
        return await ContentImageUploader(jsonRequest, fd.get('file'), OSSData);
    }

    const getOSSData = async () => {
        const result = await jsonRequest.get("/common/oss-sign", {
            type: "picture",
        }).then((resp: any) => resp.json());
        return result.data;
    };

    useEffect(() => {
        handleLoadData();
    }, []);

    const handleLoadData = async () => {
        var response = await jsonRequest.get("/back/other/pulse-guide", {})
        form.setFieldValue('content', await replaceImageSrcWithInit(response.body.data));
    }

    const handleSubmit = async (values: any) => {
        // 处理 content 中的图片 URL
        if (values?.content) {
            values.content = values.content.replace(/(src="[^?"]+)(?:\?[^"]+)?/g, '$1');
        }
        var result = await jsonRequest.post(`/back/other/pulse-guide`, {
            content: values.content,
        }).then((resp: any) => resp.json());
        if (result?.code !== 0) {
            message.error(result?.msg || "保存失败");
            return;
        }
        // 保存成功后重新加载数据
        await handleLoadData();
        message.success("保存成功");
    }

    return (
        <div>
            <h1>把脉指南</h1>
            <Form form={form} className="GuideForm" onFinish={handleSubmit}>
                <Form.Item name="content" rules={[{ required: true, message: '不能为空' }]} style={{ height: 370 }}>
                    <CustomQuill
                        style={{ height: 300 }}
                        imgUploadApi={imgUploadApi}
                        placeholder={"请填写内容"}
                        extendSize={["20px", "22px", "24px"]}
                        className="RichText"
                    />
                </Form.Item>
                <Form.Item wrapperCol={{ span: 24 }} style={{ textAlign: 'center', marginTop: 16 }}>
                    <Button type="primary" htmlType="submit" size="large">
                        保存
                    </Button>
                </Form.Item>
            </Form>
        </div>
    )
}